// extracted by mini-css-extract-plugin
export default {"ace-c-saa-people-and-rooms-panel--spacer":"saa-people-and-rooms-panel--spacer---6b892efe"};